import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    fileImportLogsData: [],
    fileImportAuditLogsData: [],
    // selectedHistoryDetails: null,
    pagination: null,
    loading: false,
    error: null,
};

export const getAllFileImportLogs = createAsyncThunk(
    "card-status/file-import-logs/get-all-logs",
    async ({ user, pagination, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            const { pageSize, currentPage } = pagination;
            // const { sortColumn, isAsce } = orderBy;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.fileImport;

            const apiURL = base + endpointpath + `/${pageSize}/${currentPage}`;

            const response = await axiosInstance.post(apiURL, search);

            if(response?.data?.responseCode === '404') {
                toast.error(response?.data?.responseDescription);
            }

            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const getAllFileImportAuditLogs = createAsyncThunk(
    "card-status/file-import-Audit-logs/get-all-logs",
    async ({ user, pagination, search }) => {
        try {
            const { url, endpoint } = user?.routesConfig;
            const { pageSize, currentPage } = pagination;
            // const { sortColumn, isAsce } = orderBy;

            const base = url?.acsbackofficemanagement;
            const endpointpath = endpoint?.acsbackofficemanagement?.getAudit;

            const apiURL = base + endpointpath + `/${pageSize}/${currentPage}`;

            const response = await axiosInstance.post(apiURL, search);

            if(response?.data?.responseCode === '404') {
                toast.error(response?.data?.responseDescription);
            }

            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const cardStatusFileImportLogsSlice = createSlice({
    name: "card-status-management/file-import-logs",
    initialState,
    reducers: {
        resetSelected: (state) => {
            state.selectedCardStatusDetails = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // GET ALL LOGS
            .addCase(getAllFileImportLogs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllFileImportLogs.fulfilled, (state, action) => {
                const { data, currentPage, pageSize, totalItem, totalPages } = action?.payload || {};
                state.loading = false;
                state.fileImportLogsData = data;
                state.pagination = {
                    currentPage: currentPage || 0,
                    pageSize: pageSize || 10,
                    totalItem,
                    totalPages
                };
            })
            .addCase(getAllFileImportLogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            // GET ALL AUDIT LOGS
            .addCase(getAllFileImportAuditLogs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllFileImportAuditLogs.fulfilled, (state, action) => {
                const { data, currentPage, pageSize, totalItem, totalPages } = action?.payload || {};
                state.loading = false;
                state.fileImportAuditLogsData = data;
                state.pagination = {
                    currentPage: currentPage || 0,
                    pageSize: pageSize || 10,
                    totalItem,
                    totalPages
                };
            })
            .addCase(getAllFileImportAuditLogs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetSelected } = cardStatusFileImportLogsSlice.actions;

export default cardStatusFileImportLogsSlice.reducer;